export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'not_specified', label: 'Not Specified' },
];

export const HYPOALLERGENIC_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'not_specified', label: 'Not Specified' },
];

export function normalizeSelectValue(value, fallback = 'not_specified') {
  if (typeof value === 'boolean') return value ? 'yes' : 'no';
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
  return normalized || fallback;
}

export function formatGender(value) {
  const normalized = normalizeSelectValue(value);
  return GENDER_OPTIONS.find(option => option.value === normalized)?.label || 'Not Specified';
}

export function formatHypoallergenic(value) {
  const normalized = normalizeSelectValue(value);
  return HYPOALLERGENIC_OPTIONS.find(option => option.value === normalized)?.label || 'Not Specified';
}

export function hasSpecifiedValue(value) {
  return Boolean(value && value !== 'not_specified');
}